import React, {Component} from 'react'
import moment from 'moment'
import {Input} from 'reactstrap'
import ReactTable from 'react-table'
import {Mutation} from 'react-apollo'
import 'react-table/react-table.css'

import LoadingButton from "../LoadingButton"

import {enumerateMonthsBetweenDates} from '../../../lib/dates'
import downloadProjectClientInvoiceMutation from '../../../queries/server/mutations/download_project_client_invoice'

const {format} = Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP'
})

const dates = enumerateMonthsBetweenDates('2015-01-01', moment().format('YYYY-MM-DD'))

const renderDateOptions = () => {
  return dates.map((date, index) => {
    const mDate = moment(date)
    return <option value={mDate.format('YYYY-MM')}>{mDate.format('YYYY MMMM')}</option>
  }).reverse()
}

const getCreditNotesTotal = (creditNotes) => {
  return creditNotes.reduce((carry, {invoice_total}) => {
    carry += invoice_total || 0
    return carry
  }, 0)
}

export default class ProjectsTable extends Component {

  render() {
    return (<ReactTable
        data={this.props.data}
        loading={this.props.loading}
        pages={this.props.pages}
        style={{display: 'flex', flex: 1, fontSize: '14px'}}
        pageSizeOptions={[5, 10, 20, 25, 50, 100]}
        columns={[
            {
              Header: 'Invoice No',
              id: 'invoice_number',
              accessor: 'invoice_number'
            },
            {
                Header: "Project ID",
                id: 'project_id',
                accessor: 'project.project_id'
            },
            {
              Header: "Project Name",
              id: 'project_name',
              accessor: 'project.name'
            },
            {
              Header: "Client Name",
              id: 'client_name',
              accessor: 'client.name'
            },
            {
              Header: "Client Contacts",
              id: 'client_contacts',
              accessor: 'client.contacts',
              sortable: false,
              filterable: false,
              Cell: row => (
                <div>
                    {row.value.map(({contact_id, first_name, last_name}) => <div key={contact_id}>{first_name} {last_name}</div>)}
                </div>
              )
            },
            {
              Header: "Created At",
              id: 'created_at',
              accessor: ({created_at}) => moment(created_at).format('DD/MM/YYYY'),
              Filter: ({filter, onChange}) => {
                return (
                  <Input type="select" onChange={(evt) => onChange(evt.target.value)} value={filter ? filter.value : ''}>
                    <option value="">Show All</option>
                    {renderDateOptions()}
                  </Input>
                )
              }
            },
            {
              Header: "Issued At",
              id: 'issued_at',
              accessor: ({issued_at}) => (issued_at) ? moment(issued_at).format('DD/MM/YYYY') : '-',
              Filter: ({filter, onChange}) => {
                return (
                  <Input type="select" onChange={(evt) => onChange(evt.target.value)} value={filter ? filter.value : ''}>
                    <option value="">Show All</option>
                    <option value="SHOW_NULL">Show Not Issued</option>
                    {renderDateOptions()}
                  </Input>
                )
              }
            },
            {
              Header: "Paid At",
              id: 'paid_at',
              accessor: ({paid_at}) => (paid_at) ? moment(paid_at).format('DD/MM/YYYY') : '-',
              Filter: ({filter, onChange}) => {
                return (
                  <Input type="select" onChange={(evt) => onChange(evt.target.value)} value={filter ? filter.value : ''}>
                    <option value="">Show All</option>
                    <option value="SHOW_NULL">Show Not Paid</option>
                    {renderDateOptions()}
                  </Input>
                )
              }
            },
            {
              Header: "Total exc VAT",
              id: 'invoice_total',
              accessor: ({invoice_total}) => format(invoice_total),
              sortable: false,
              filterable: false,
            },
            {
              Header: "Total Credit Notes",
              id: 'credit_notes',
              sortable: false,
              filterable: false,
              accessor: ({credit_notes}) => {
                const cnAmount = credit_notes.reduce((carry, {invoice_total}) => {
                  carry += invoice_total || 0
                  return carry
                }, 0)

                return format(cnAmount)
              }
            },
            {
              Header: "Grand Total",
              id: 'grand_total',
              accessor: ({invoice_total, credit_notes}) => {
                const total = (invoice_total || 0) + getCreditNotesTotal(credit_notes)
                return format(total)
              },
              sortable: false,
              filterable: false,
            },
            {
              Header: 'Actions',
              id: 'id',
              sortable: false,
              filterable: false,
              width: 160,
              Cell: ({original}) => {
                return (<div className="d-flex flex-row justify-content-end" style={{flex: 1}}>

                    <LoadingButton
                        className="square-btn mr-2"
                        size="sm"
                        icon="edit"
                        color="warning"
                        onClick={() => {
                          const {onSelect} = this.props
                          if (onSelect) onSelect(original.id)
                        }}
                    />

                    <LoadingButton
                        className="square-btn mr-2"
                        size="sm"
                        icon="hand-holding-usd"
                        color="secondary"
                        onClick={() => {
                          const {onAddCreditNote} = this.props
                          if (onAddCreditNote) onAddCreditNote(original.id)
                        }}
                    />

                    
                    <Mutation mutation={downloadProjectClientInvoiceMutation}>
                        {(downloadProjectClientInvoiceMutationFunc, {loading}) => (
                            <LoadingButton
                                className="square-btn mr-2"
                                size="sm"
                                icon="file-download"
                                loading={loading}
                                color="primary"
                                onClick={() => {
                                    downloadProjectClientInvoiceMutationFunc({variables: {url: original.invoice_url}})
                                        .then(({data}) => {
                                            const {downloadProjectClientInvoice} = data

                                            window.open(downloadProjectClientInvoice)
                                        })
                                }}
                            />
                        )}

                    </Mutation>
                        
                    <LoadingButton
                        className="square-btn"
                        size="sm"
                        icon="trash-alt"
                        color="danger"
                        onClick={() => {
                          const {onDelete} = this.props
                          if (onDelete) onDelete(original.id)
                        }}
                    />
                </div>)
              }
            }

        ]}
        className="-striped -highlight"
        filterable
        showPagination={true}
        manual
        onFetchData={this.props.onFetchData}
    />)
}

}